import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import Modal from 'component/utils/Modal'
import New from 'component/helpConfiguration/Modal/HelpConfigModalNew'
import Remove from 'component/helpConfiguration/Modal/HelpConfigModalRemove'
import Edit from 'component/helpConfiguration/Modal/HelpConfigModalEdit'
import Success from 'component/helpConfiguration/Modal/HelpConfigModalSuccess'

const REMOVE = 'HELP_CONFIG_REMOVE'
const EDIT = 'HELP_CONFIG_EDIT'
const NEW = 'HELP_CONFIG_NEW'
const SUCCESS = 'HELP_CONFIG_SUCCESS'

class HelpConfigModal extends Component {
  renderContent = (props) => {
    switch (props.modalType) {
      case NEW:
        return <New {...props} />
      case REMOVE:
        return <Remove {...props} />
      case EDIT:
        return <Edit {...props} />
      case SUCCESS:
        return <Success {...props} />
      default:
        return <Fragment />
    }
  }

  render() {
    return (
      <Modal closeModal={this.props.closeModal} size={this.props.size || 'lg'}>
        {this.renderContent(this.props)}
      </Modal>
    )
  }
}

HelpConfigModal.propTypes = {
  translate: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  modalType: PropTypes.string.isRequired,
  onSubmit: PropTypes.func,
  values: PropTypes.object,
  initialValues: PropTypes.object,
  user: PropTypes.object,
  size: PropTypes.string,
}

export default HelpConfigModal
